import { useLayoutEffect, useRef, useState } from "react";
import * as s from "../StatsStyled";
import OrgStackedBarChart from "./BarGraph";
import LineGraph from "./LineGraph";
import OsDonutChart from "./DonutGraph";
import ChartLegend from "./ChartLegend";
import GraphHeader from "./ChartHeader";
import {
  CategoryDef,
  LegendType,
} from "api/interfaces/chartInterface.interface";
import { statsInterval } from "api/interfaces/widgetInterface.interface";
import Spinner from "components/atoms/loader/Spinner";
import { useStatsWidget } from "./GridChartItem";

interface Props {
  rows: any[];
  items: CategoryDef[];
  onChangeInterval?: (interval: statsInterval) => void;
  interval?: statsInterval;
  unit?: string;
  legend?: LegendType[];
  isLoading?: boolean;
  areaOpacity?: number;
}
export default function ChartWrapper({
  rows,
  unit,
  items,
  onChangeInterval,
  interval,
  isLoading = false,
  areaOpacity,
  legend = [],
}: Props) {
  const {
    chartId,
    onReplaceChart,
    onRemoveChart,
    hiddenCharts,
    onChangeGraphType,
    ...dataItems
  } = useStatsWidget();
  const { graphType, groupMode, lengedType } = dataItems;
  const chartRef = useRef<HTMLDivElement>(null);
  const [activeOrgs, setActiveOrgs] = useState<string[]>(() =>
    (legend ?? []).filter((item) => item.key).map((item) => item.key as string)
  );
  const [width, setWidth] = useState(0);

  const toggleOrg = (key: string) => {
    setActiveOrgs((prev) => {
      if (prev.includes(key)) {
        return prev.filter((k) => k !== key);
      }
      return [...prev, key];
    });
  };

  useLayoutEffect(() => {
    const el = chartRef.current;
    if (!el) return;
    setWidth(el.clientWidth);

    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect?.width ?? 0;
      setWidth(w);
    });

    ro.observe(el);
    return () => ro.disconnect();
  }, [isLoading]);
  if (chartId === "cloudStorage") {
    console.log(rows, "rows");
    console.log(items, "items");
  }
  return (
    <s.Chart.Card>
      {/* Top Bar */}
      <GraphHeader
        useInterval={graphType !== "donut"}
        isShowButton={items.length > 0 && graphType !== "donut"}
        items={items}
        onChangeInterval={onChangeInterval}
        interval={interval}
      />
      {/* Chart */}
      {isLoading ? (
        <Spinner />
      ) : (
        <s.Chart.GraphContainer>
          {graphType === "donut" ? (
            <OsDonutChart rows={rows} unit={unit} items={items} />
          ) : (
            <s.Chart.GraphWrapper
              ref={chartRef}
              isShowButton={items.length > 1 && graphType !== "donut"}
              isShowLegend={lengedType !== "list"}
              reduced={width < 300}
            >
              {width > 0 && graphType === "stackedBar" && (
                <OrgStackedBarChart
                  rows={rows}
                  activeOrgs={activeOrgs}
                  width={width}
                  items={items}
                  groupMode={groupMode}
                  unit={unit}
                  enableGridY
                />
              )}
              {width > 0 && graphType === "line" && (
                <LineGraph
                  items={items}
                  rows={rows}
                  width={width}
                  activeOrgs={activeOrgs}
                  areaOpacity={areaOpacity}
                  unit={unit}
                  enableGridY
                />
              )}
            </s.Chart.GraphWrapper>
          )}
          {legend.length > 0 && (
            <ChartLegend
              legend={legend}
              lengedType={lengedType ?? "value"}
              activeOrgs={activeOrgs}
              toggleOrg={toggleOrg}
            />
          )}
        </s.Chart.GraphContainer>
      )}
    </s.Chart.Card>
  );
}
